export const SectionHeading = (props) => {
  const { title, link } = props
  return (
    <div className="section-heading row align-items-center mb-4">
      <h3 className="col-md-auto mb-0 pe-md-0 fw-bold text-dark">{title}</h3>
      <div className="col d-none d-md-inline-block">
        <div className="d-block border-bottom border-primary" />
      </div>
      {link && (
        <div className="col-md-auto mb-0 ps-md-0 text-uppercase">
          <a href={link.url} aria-label={`${link.title} ${title}`}>
            <small>{link.title} </small>
            <i className="fas fa-chevron-right" />
          </a>
        </div>
      )}
    </div>
  )
}
